import i18n from 'app-i18n';

export const getTransactionIdData = (
  type,
  { orderId, giftCardId, scanToPayTxId },
) => {
  let title, detail;

  switch (type) {
    case 'ORDER':
      title = i18n.t('drawer.transactionDrawer.orderId');
      detail = orderId;
      break;
    case 'SCAN_TO_PAY':
      title = i18n.t('drawer.transactionDrawer.scanToPayTransactionId');
      detail = scanToPayTxId;
      break;
    default:
      title = i18n.t('drawer.transactionDrawer.giftCardNumber');
      detail = giftCardId;
  }

  return { title, detail };
};
